
    import './styles.scoped.css';
    export default {
  "root-refresh": "awsui_root-refresh_1hmm4_go3uc_1",
  "root-no-navigation-padding": "awsui_root-no-navigation-padding_1hmm4_go3uc_5",
  "root-no-tools-padding": "awsui_root-no-tools-padding_1hmm4_go3uc_8",
  "root-mobile": "awsui_root-mobile_1hmm4_go3uc_11",
  "notifications-sticky": "awsui_notifications-sticky_1hmm4_go3uc_15",
  "notifications-refresh": "awsui_notifications-refresh_1hmm4_go3uc_20",
  "notifications-refresh-mobile": "awsui_notifications-refresh-mobile_1hmm4_go3uc_24"
};
  